/*
 * nadi-menu-deals.js — the salon deals stop being items 16 and 17.
 *
 * WHAT WAS MEASURED, and it is the whole argument. 2026-10-08, draft theme,
 * 375x812, drawer cache cleared first. Nadav moved his salon deals under the
 * "יש לי מספרה" door in Shopify Navigation, where they landed at the BOTTOM of
 * a seventeen-row list. Opening the drawer and expanding that door puts the
 * first child at y=400; "מבצעים למספרות גברים" renders at y=1060 and
 * "מבצעים למספרות נשים" at y=1104 — 248px and 292px below an 812px fold. To
 * reach the two rows that exist in order to be found, a salon owner opens the
 * drawer, taps the door, and scrolls past fifteen categories.
 *
 * Reordering that list in Shopify Navigation is two drags and Nadav should
 * still do it; it is his data, not the theme's. This is the other half of the
 * job, and it is deliberately written to be correct either way: the rows are
 * found by collection HANDLE, never by position, so his reorder cannot break
 * this and this does not quietly depend on it. Run before or after the drag,
 * the result is the same.
 *
 * WHAT IT DOES. Wherever those links appear they are lifted to the top of
 * their group and drawn as deals rather than as the first two of seventeen
 * categories, and the door that hides them says that deals are behind it.
 *
 *   drawer   the <li>s move to the head of their <ul>, keep their order, and
 *            get the deals treatment; the group is closed with a rule.
 *   desktop  the panel is a flex row whose link list is laid out in CSS
 *            columns, and `order` cannot reach into a CSS column. So the items
 *            move OUT of the list into a full-width strip above it, which is a
 *            flex sibling and can be ordered. It also reads better: a strip
 *            across the top of a three-column panel is a different kind of
 *            thing, which is exactly the point.
 *
 * WHICH ROWS ARE DEALS — by handle, listed below. The handles are stable:
 * Nadav is renaming the TITLES to "מבצעים למספרות ..." and a title change never
 * moves a handle. Note the women's collection really is `...-נשים-1`; the
 * unsuffixed handle does not exist, which is worth knowing before anyone
 * "corrects" it.
 *
 * A title pattern follows as a fallback, for a third deals collection added
 * later. CLAUDE.md warns against keying off merchant-entered text, and that
 * warning is about matching a CATALOGUE — the per-unit pricing rule that
 * whitelisted one spelling of an option name out of ~500 products. This is not
 * a catalogue: it is two links in one menu Nadav controls, the handles carry
 * the real work, and the pattern only widens the net. If a deal is ever missed
 * here, add its handle; do not loosen the pattern.
 *
 * COLOUR. Olive #4C5836 throughout — white on it is 7.62:1. Red is left alone
 * on purpose: it belongs to the "חם" badge on "מבצעים חמים", which is the
 * private-customer deals door. Two red badges in one menu would cancel each
 * other out, and these two doors are aimed at two different people.
 *
 * Runs at every width. The burial was measured on the phone, which is 95% of
 * this store, and the desktop panel holds the same links.
 */
(function () {
  'use strict';

  /* WHICH COLLECTIONS ARE DEALS, AND HOW DEEP THE BEST ONE IS — both read from
     #NadiMenuDeals, printed by snippets/nadi-menu-meta.liquid:

         {"דילים-למספרות-גברים": {"n": 18, "off": 58}, …}

     This file used to carry its own copy of the handle list. It does not any
     more: the keys of that block ARE the list, so "these are the deals" is
     stated once, in Liquid, beside the figures it produces. Adding a third
     deals collection is one handle in that snippet and nothing here.

     If the block is missing the menu degrades to plain rows rather than
     breaking — the pattern below still catches them, and a row with no figure
     simply shows no figure. */
  var DEALDATA = (function () {
    try {
      var el = document.getElementById('NadiMenuDeals');
      return el ? (JSON.parse(el.textContent) || {}) : {};
    } catch (e) { return {}; }
  })();

  var DEALS = Object.keys(DEALDATA);

  var FALLBACK = /^\s*(מבצעים|דילים)\s+למספרות/;

  /* Published product counts by handle, printed on every page by
     snippets/nadi-menu-meta.liquid. all_products_count counts what the
     customer can actually see, which is why these read 18 and 20 where the
     Admin API reports 24 and 27 — the difference is unpublished products, and
     the number on the row has to be the number the page will show. */
  var COUNTS = (function () {
    try {
      var el = document.getElementById('NadiMenuMeta');
      return el ? (JSON.parse(el.textContent) || {}) : {};
    } catch (e) { return {}; }
  })();

  function handleOf(a) {
    var m = (a.getAttribute('href') || '').match(/\/collections\/([^/?#]+)/);
    if (!m) return '';
    try { return decodeURIComponent(m[1]); } catch (e) { return m[1]; }
  }

  function isDeal(a) {
    var h = handleOf(a);
    if (!h) return false;
    if (DEALS.indexOf(h) !== -1) return true;
    return FALLBACK.test(a.textContent || '');
  }

  /* THE ROW ITSELF: a name, what the deal is worth, and how many there are.
     The count alone was the weak version of this — 18 says how MANY, and a
     salon owner buying in bulk is moved by how MUCH. "עד 58% הנחה" is the
     line that does the work; the pill keeps the count beside it.

     The second line is drawn ONLY when there is a real figure behind it.
     A collection with nothing discounted reports off:0 and gets no claim,
     because "עד 0% הנחה" is worse than saying nothing. */
  function dress(a) {
    if (!a) return;

    /* nadi-menu.js prints a plain muted count on every desktop panel link. On
       a pinned row that count is replaced by the pill, not joined by it: the
       first push drew both and the row read "1818". That script now skips a
       link already carrying .nadi-dealrow__n, and this drops its span if it
       got there first — so the pair is correct in either order, which matters
       because both are MutationObserver-driven and neither can be sequenced. */
    var twin = a.querySelector('.nadi-mm__n:not(.nadi-dealrow__n)');
    if (twin) twin.remove();
    if (a.querySelector('.nadi-dealrow__txt')) return;   /* already dressed */

    var h = handleOf(a);
    var d = DEALDATA[h] || {};
    var n = d.n || COUNTS[h] || 0;
    var off = d.off || 0;

    /* The label as the menu gives it, before anything is added. textContent
       would also swallow a pill from an earlier pass; that was removed above. */
    var label = (a.textContent || '').replace(/\s+/g, ' ').trim();
    if (!label) return;

    /* Kalles puts an icon inside some links. Keep it — the rebuild below
       replaces the link's contents, and an icon silently dropped is the kind
       of regression nobody notices until it is old. */
    var icon = a.querySelector('i, svg');

    a.textContent = '';
    if (icon) a.appendChild(icon);

    var txt = document.createElement('span');
    txt.className = 'nadi-dealrow__txt';

    var main = document.createElement('span');
    main.className = 'nadi-dealrow__main';
    main.textContent = label;
    txt.appendChild(main);

    if (off > 0) {
      var sub = document.createElement('span');
      sub.className = 'nadi-dealrow__sub';
      sub.textContent = 'עד ' + off + '% הנחה';
      txt.appendChild(sub);
    }
    a.appendChild(txt);

    if (n) {
      var s = document.createElement('span');
      s.className = 'nadi-dealrow__n';
      s.textContent = n;
      a.appendChild(s);
    }
  }

  /* The door. An outlined olive tag, so it is the same colour as the rows
     behind it without becoming a third filled badge competing with them. */
  function markDoor(li) {
    var a = li.querySelector(':scope > a');
    if (!a || a.querySelector('.nadi-dealdoor')) return;
    var s = document.createElement('span');
    s.className = 'nadi-dealdoor';
    s.textContent = 'מבצעים';
    (a.querySelector('.t4s-nav_link_txt') || a).appendChild(s);
  }

  function drawer() {
    document.querySelectorAll('#t4s-menu-drawer ul.t4s-sub-menu').forEach(function (ul) {
      var hits = [].slice.call(ul.children).filter(function (li) {
        var a = li.querySelector(':scope > a');
        return a && isDeal(a);
      });
      if (!hits.length) return;

      if (ul.dataset.nadiDeals !== '1') {
        /* A fragment moves them as a block, so their order relative to each
           other survives the lift. */
        var frag = document.createDocumentFragment();
        hits.forEach(function (li) { frag.appendChild(li); });
        ul.insertBefore(frag, ul.firstChild);
        ul.dataset.nadiDeals = '1';
      }

      hits.forEach(function (li, i) {
        li.classList.add('nadi-dealrow');
        li.classList.toggle('nadi-dealrow--end', i === hits.length - 1);
        dress(li.querySelector(':scope > a'));
      });

      var door = ul.closest('li.t4s-item-level-0');
      if (door) markDoor(door);
    });
  }

  function panels() {
    document.querySelectorAll('.t4s-type__drop > .t4s-sub-menu').forEach(function (panel) {
      var list = panel.querySelector(':scope > .t4s-lazy_menu');
      if (!list) return;

      var hits = [].slice.call(list.children).filter(function (li) {
        if (!li.classList.contains('t4s-menu-item')) return false;
        var a = li.querySelector(':scope > a');
        return a && isDeal(a);
      });
      var strip = panel.querySelector(':scope > .nadi-dealstrip');
      if (!hits.length) return;

      if (!strip) {
        strip = document.createElement('div');
        strip.className = 'nadi-dealstrip';
        var h = document.createElement('span');
        h.className = 'nadi-dealstrip__h';
        h.textContent = 'מבצעים למספרות';
        strip.appendChild(h);
        panel.insertBefore(strip, panel.firstChild);
      }

      hits.forEach(function (li) {
        li.classList.add('nadi-dealrow');
        dress(li.querySelector(':scope > a'));
        if (li.parentElement !== strip) strip.appendChild(li);
      });

      var door = panel.closest('li.t4s-type__drop');
      if (door) markDoor(door);
    });
  }

  function run() {
    try { drawer(); } catch (e) { /* one surface failing must not take the other */ }
    try { panels(); } catch (e) { /* idem */ }
  }

  run();

  /* The drawer is fetched from /search?view=mn and the desktop panels from
     /search?section_id=dropdown-menu, both on first open and both re-injected
     from sessionStorage for half an hour after. Same answer the cart bar, the
     brand line and the menu sizer all reached: watch rather than assume, and
     stay idempotent. */
  if (window.MutationObserver) {
    var pending = null;
    new MutationObserver(function () {
      if (pending) return;
      pending = setTimeout(function () { pending = null; run(); }, 150);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
